<template>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
        style="opacity: 0.5;">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <!-- Header Start -->
    <div class="modal fade" id="costumModalkurva" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);width: 98vw;height: 98%;">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content" style="height: auto;min-width: 90vw; min-height: 98%;">
                <div class="modal-header">
                    <h4 class="modal-title">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">
                            Informasi
                        </span>
                        <span v-else>
                            Information
                        </span>
                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-center"
                    style="height: auto;min-width: 90vw; min-height: 98%;overflow: auto;">
                    <div class="row text-center">
                        <div class="row">
                            <div class="col-sm-12 text-center">
                                <button type="button" class="btn btn-success btn-sm text-white lebar2"
                                    data-toggle="tooltip" data-placement="left" title="Unduh excel.."
                                    @click="eksportexcel()">
                                    <i class="fas fa-download"></i>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Unduh Data .xlsx
                                    </span>
                                    <span v-else>
                                        Download Data .xlsx
                                    </span>
                                </button>
                            </div>
                            <div class="col-sm-12 text-center">&nbsp;</div>
                            <div class="col-sm-12 text-center">
                                <label>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')" class="hitam">
                                        dari minggu ke&nbsp;
                                    </span>
                                    <span v-else class="hitam">
                                        from week&nbsp;
                                    </span>
                                </label>
                                <select v-model="awalminggunya" @change="ambiltanggalawalterpilih($event)">
                                    <option v-for="index in akhirminggu" :key="index">
                                        {{ index }}
                                    </option>
                                </select>
                                &nbsp;
                                <label>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')" class="hitam">
                                        ke minggu ke&nbsp;
                                    </span>
                                    <span v-else class="hitam">
                                        to week&nbsp;
                                    </span>
                                </label>
                                <select v-model="akhirminggunya" @change="ambiltanggalterpilih($event)">
                                    <option v-for="index in akhirminggu" :key="index">
                                        {{ index }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-sm-12 text-center">
                                <LineChartMonitoringProyek type="line" :options="chartOptionsmonitoring"
                                    :series="seriesmonitoring" height="500">
                                </LineChartMonitoringProyek>
                            </div>
                            <div class="col-sm-12 text-center">
                                <label>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">PROGRES REALISASI FISIK</span>
                                    <span v-else>PHYSICAL REALIZATION PROGRESS</span>
                                </label>
                                <div class="table-responsive table-wrapper">
                                    <table class="table m-0" id="tabeldata11" style="font-size: smaller;">
                                        <thead>
                                            <tr>
                                                <th style="width: 50px;">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Minggu ke-
                                                    </span>
                                                    <span v-else>
                                                        Week to-
                                                    </span>
                                                </th>
                                                <template v-for="(datalist, urutlist) in tempjudul" :key="urutlist">
                                                    <th style="width: 50px;">
                                                        {{ datalist }}
                                                    </th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Rencana
                                                    </span>
                                                    <span v-else>
                                                        Plan
                                                    </span>
                                                </td>
                                                <template v-for="(datalist, urutlist) in temprencanafisik"
                                                    :key="urutlist">
                                                    <td class="text-center">
                                                        {{ G_numFormatKoma(datalist) }}
                                                    </td>
                                                </template>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Realisasi
                                                    </span>
                                                    <span v-else>
                                                        Realization
                                                    </span>
                                                </td>
                                                <template v-for="(datalist, urutlist) in temprealisasifisik"
                                                    :key="urutlist">
                                                    <td class="text-center">
                                                        {{ G_numFormatKoma(datalist) }}
                                                    </td>
                                                </template>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Deviasi
                                                    </span>
                                                    <span v-else>
                                                        Deviation
                                                    </span>
                                                </td>
                                                <template v-for="(datalist, urutlist) in tempdeviasifisik"
                                                    :key="urutlist">
                                                    <td class="text-center">
                                                        {{ G_numFormatKoma(datalist) }}
                                                    </td>
                                                </template>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-sm-12 text-center">
                                <label>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">PROGRES REALISASI
                                        KEUANGAN</span>
                                    <span v-else>FINANCIAL REALIZATION PROGRESS</span>
                                </label>
                                <div class="table-responsive table-wrapper">
                                    <table class="table m-0" id="tabeldata11" style="font-size: smaller;">
                                        <thead>
                                            <tr>
                                                <th style="width: 50px;">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Minggu ke-
                                                    </span>
                                                    <span v-else>
                                                        Week to-
                                                    </span>
                                                </th>
                                                <template v-for="(datalist, urutlist) in tempjudul" :key="urutlist">
                                                    <th style="width: 50px;">
                                                        {{ datalist }}
                                                    </th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Rencana
                                                    </span>
                                                    <span v-else>
                                                        Plan
                                                    </span>
                                                </td>
                                                <template v-for="(datalist, urutlist) in temprencanakeu"
                                                    :key="urutlist">
                                                    <td class="text-center">
                                                        {{ G_numKoma(datalist) }}
                                                    </td>
                                                </template>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Realisasi
                                                    </span>
                                                    <span v-else>
                                                        Realization
                                                    </span>
                                                </td>
                                                <template v-for="(datalist, urutlist) in temprealisasikeu"
                                                    :key="urutlist">
                                                    <td class="text-center">
                                                        {{ G_numKoma(datalist) }}
                                                    </td>
                                                </template>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Deviasi
                                                    </span>
                                                    <span v-else>
                                                        Deviation
                                                    </span>
                                                </td>
                                                <template v-for="(datalist, urutlist) in tempdeviasikeu"
                                                    :key="urutlist">
                                                    <td class="text-center">
                                                        {{ G_numKoma(datalist) }}
                                                    </td>
                                                </template>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-sm-6 text-center">
                                <label>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">DATA TEKNIS KEGIATAN</span>
                                    <span v-else>TECHNICAL DATA OF ACTIVITIES</span>
                                </label>
                                <div class="table-responsive table-wrapper">
                                    <table class="table m-0" id="tabeldata5" style="font-size: smaller;">
                                        <thead>
                                            <tr>
                                                <th style="width: 50px;">No</th>
                                                <th style="width: 100px;"><span
                                                        v-if="(bahasa === null) || (bahasa == 'ina')">Informasi</span>
                                                    <span v-else>Information</span>
                                                </th>
                                                <th style="width: 100px;"><span
                                                        v-if="(bahasa === null) || (bahasa == 'ina')">Data</span>
                                                    <span v-else>Data</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td class="text-center">
                                                    1
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Lokasi</span>
                                                    <span v-else>Location</span>
                                                </td>
                                                <td class="text-left">
                                                    {{ Lokasi }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">
                                                    2
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Tanggal NOL
                                                        AWP</span>
                                                    <span v-else>AWP NOL Date</span>
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">{{
                                                        G_formatDateNonWIB(tanggal1) }}</span>
                                                    <span v-else>{{ G_formatDateNonWIBEng(tanggal1) }}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">
                                                    3
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Tanggal NOL
                                                        RC</span>
                                                    <span v-else>RC NOL Date</span>
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">{{
                                                        G_formatDateNonWIB(tanggal2) }}</span>
                                                    <span v-else>{{ G_formatDateNonWIBEng(tanggal2) }}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">
                                                    4
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Anggaran
                                                        AWP</span>
                                                    <span v-else>AWP Budget</span>
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">{{
                                                        G_numFormat(AWP) }}</span>
                                                    <span v-else>{{ G_numFormat(AWP) }}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">
                                                    5
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Nilai
                                                        Kontrak</span>
                                                    <span v-else>Contract Value</span>
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">{{
                                                        G_numFormat(NILAIKONTRAK) }}</span>
                                                    <span v-else>{{ G_numFormat(NILAIKONTRAK) }}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">
                                                    6
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Tanggal
                                                        Kontrak</span>
                                                    <span v-else>Contract Date</span>
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">{{
                                                        G_formatDateNonWIB(MULAI) }}</span>
                                                    <span v-else>{{ G_formatDateNonWIBEng(MULAI) }}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">
                                                    7
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Selesai
                                                        Kontrak</span>
                                                    <span v-else>End of contract</span>
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">{{
                                                        G_formatDateNonWIB(SELESAI) }}</span>
                                                    <span v-else>{{ G_formatDateNonWIBEng(SELESAI) }}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">
                                                    8
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Rekanan</span>
                                                    <span v-else>Partner</span>
                                                </td>
                                                <td class="text-left">
                                                    {{ KONTRAKTOR }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">
                                                    9
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Adendum</span>
                                                    <span v-else>Addendum</span>
                                                </td>
                                                <td class="text-left">
                                                    {{ ADENDUM }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-sm-6 text-center">
                                <label>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">DOKUMENTASI <span
                                            v-if="foto_mingguke != ''">MINGGU KE- {{
                                                foto_mingguke }}</span> </span>
                                    <span v-else>DOCUMENTATION <span v-if="foto_mingguke != ''">WEEK - {{ foto_mingguke
                                    }}</span></span>
                                </label><br></br>
                                <img :src="foto" class="img-fluid gambar" style="height: 300px;">
                                <br></br>
                            </div>
                            <div class="col-sm-12 text-center">&nbsp;<br></br>&nbsp;</div>
                            <div class="col-sm-12 text-center">
                                <div class="table-responsive table-wrapper">
                                    <table class="table m-0" id="tabeldata6" style="font-size: smaller;">
                                        <thead>
                                            <tr>
                                                <th style="width: 100px;"><span
                                                        v-if="(bahasa === null) || (bahasa == 'ina')">Kendala</span>
                                                    <span v-else>Constraint</span>
                                                </th>
                                                <th style="width: 100px;"><span
                                                        v-if="(bahasa === null) || (bahasa == 'ina')">Tindak
                                                        Lanjut</span>
                                                    <span v-else>Follow-up</span>
                                                </th>
                                                <th style="width: 300px;"><span
                                                        v-if="(bahasa === null) || (bahasa == 'ina')">Target Waktu Dan
                                                        Penanggungjawab</span>
                                                    <span v-else>Time Target and Responsible Implementation Unit</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(datalist, urutlist) in kendalaarray" :key="urutlist">
                                                <td class="text-left">
                                                    <span v-html="Dekriptext(datalist.kendala)"></span>
                                                </td>
                                                <td class="text-left">
                                                    <span v-html="Dekriptext(datalist.tindaklanjut)"></span>
                                                </td>
                                                <td class="text-left">
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        {{ G_formatDateNonWIB(datalist.target_penyelesaian) }}
                                                    </span>
                                                    <span v-else>
                                                        {{ G_formatDateNonWIBEng(datalist.target_penyelesaian) }}
                                                    </span>

                                                    , {{ datalist.penanggungjawab }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-center">
                    <div class="row">
                        <div class="col-sm-12 text-center">
                            <button class="btn btn-danger2 text-white" placeholder="Tutup" data-toggle="tooltip"
                                data-placement="left" title="Tutup.." style="color: black;" @click="tutupmodalkurvas()">
                                <b>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                        Tutup
                                    </span>
                                    <span v-else>
                                        Close
                                    </span>
                                </b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid bg-breadcrumb">
        <div class="container text-center py-5" style="max-width: 900px;">
            <h3 class="text-white display-3 mb-4 wow fadeInDown pmisputih" data-wow-delay="0.1s">
                <span v-if="(bahasa === null) || (bahasa == 'ina')">MONITORING DAN EVALUASI</span>
                <span v-else>MONITORING AND EVALUATION</span>
            </h3>
            <ol class="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                <li class="breadcrumb-item">
                    <a href="/">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Beranda</span>
                        <span v-else>Home</span>
                    </a>
                </li>
                <li class="breadcrumb-item active text-warning">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Monitoring dan evaluasi</span>
                    <span v-else>Monitoring and evaluation</span>
                </li>
            </ol>
        </div>
    </div>
    <!-- Header End -->
    <!-- Contact Start -->
    <div class="container-fluid blog py-2">
        <div class="container-fluid py-2">
            <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s"
                style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                <div class="sub-style">
                    <h1 class="sub-title px-3 mb-0 labelpmis" v-if="(bahasa === null) || (bahasa == 'ina')">
                        REKAPITULASI MONITORING KEGIATAN
                    </h1>
                    <h1 class="sub-title px-3 mb-0 labelpmis" v-else>
                        RECAPITULATION OF MONITORING ACTIVITIES
                    </h1>
                </div>
                <p class="mb-0" v-if="(bahasa === null) || (bahasa == 'ina')">
                    Tanggal Data: {{ G_formatDateNonWIB(tanggaldatamonev) }}
                </p>
                <p class="mb-0" v-else>
                    Data Date: {{ G_formatDateNonWIBEng(tanggaldatamonev) }}
                </p>
            </div>
            <div class="row g-4 justify-content-center">
                <div class="row">
                    <div class="col-sm-12 wow fadeInDown">
                        <div class="card cardputih collapsed-card">
                            <div class="card-header border-transparent" data-card-widget="collapse"
                                style="cursor: pointer;">
                                <label>
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Filter Kolom</span>
                                    <span v-else>Column Filter</span>
                                </label>
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                        <i class="fas fa-plus"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="card-body px-3">
                                <div class="row">
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxOuput" value="optionOuput"
                                                @click="ubahnya('showColumnOuput', 'customCheckboxOuput')">
                                            <label for="customCheckboxOuput" class="custom-control-label">
                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Komponen</span>
                                                <span v-else>Component</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxSubKomponen" value="optionSubKomponen"
                                                @click="ubahnya('showColumnSubKomponen', 'customCheckboxSubKomponen')">
                                            <label for="customCheckboxSubKomponen" class="custom-control-label">
                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Sub Komponen</span>
                                                <span v-else>Sub Component</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxOWP" value="optionOWP"
                                                @click="ubahnya('showColumnOWP', 'customCheckboxOWP')">
                                            <label for="customCheckboxOWP" class="custom-control-label">
                                                OWP</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxPenyedia" value="optionPenyedia"
                                                @click="ubahnya('showColumnPenyedia', 'customCheckboxPenyedia')">
                                            <label for="customCheckboxPenyedia" class="custom-control-label">
                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Penyedia</span>
                                                <span v-else>Provider</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxKontrak" value="optionKontrak"
                                                @click="ubahnya('showColumnKontrak', 'customCheckboxKontrak')">
                                            <label for="customCheckboxKontrak" class="custom-control-label">
                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">No Kontrak</span>
                                                <span v-else>Contract No</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxAdendum" value="optionAdendum"
                                                @click="ubahnya('showColumnAdendum', 'customCheckboxAdendum')">
                                            <label for="customCheckboxAdendum" class="custom-control-label">
                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Adendum</span>
                                                <span v-else>Addendum</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxMulai" value="optionMulai"
                                                @click="ubahnya('showColumnMulai', 'customCheckboxMulai')">
                                            <label for="customCheckboxMulai" class="custom-control-label">
                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Mulai</span>
                                                <span v-else>Start</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxSelesai" value="optionSelesai"
                                                @click="ubahnya('showColumnSelesai', 'customCheckboxSelesai')">
                                            <label for="customCheckboxSelesai" class="custom-control-label">
                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Selesai</span>
                                                <span v-else>End</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxDurasi" value="optionDurasi"
                                                @click="ubahnya('showColumnDurasi', 'customCheckboxDurasi')">
                                            <label for="customCheckboxDurasi" class="custom-control-label">
                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Durasi</span>
                                                <span v-else>Duration</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxBerjalan" value="optionBerjalan"
                                                @click="ubahnya('showColumnBerjalan', 'customCheckboxBerjalan')">
                                            <label for="customCheckboxBerjalan" class="custom-control-label">
                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Durasi
                                                    Berjalan</span>
                                                <span v-else>Running Duration</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxTersisa" value="optionTersisa"
                                                @click="ubahnya('showColumnTersisa', 'customCheckboxTersisa')">
                                            <label for="customCheckboxTersisa" class="custom-control-label">
                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Durasi
                                                    Tersisa</span>
                                                <span v-else>Remaining Duration</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxKeterangan" value="optionKeterangan"
                                                @click="ubahnya('showColumnKeterangan', 'customCheckboxKeterangan')">
                                            <label for="customCheckboxKeterangan" class="custom-control-label">
                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Keterangan</span>
                                                <span v-else>Remark</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row g-4 justify-content-center">
                <p>&nbsp;</p>
            </div>
            <div class="row g-4 justify-content-center">
                <div class="row">
                    <div class="col-sm-12 wow fadeInDown">
                        <div class="card card-white card-outline card-tabs">
                            <div class="card-header p-0 pt-1 border-bottom-0">
                                <ul class="nav nav-tabs justify-content-center" id="custom-tabs-three-tab"
                                    role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" id="custom-tabs-three-home-tab" data-toggle="pill"
                                            href="#custom-tabs-three-home" role="tab"
                                            aria-controls="custom-tabs-three-home" aria-selected="true">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">Urut Berdasar Jenis
                                                Pekerjaan</span>
                                            <span v-else>Order By Type of work</span>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" id="custom-tabs-three-profile-tab" data-toggle="pill"
                                            href="#custom-tabs-three-profile" role="tab"
                                            aria-controls="custom-tabs-three-profile" aria-selected="false">
                                            <span v-if="(bahasa === null) || (bahasa == 'ina')">Urut Berdasar Unit
                                                Pelaksana</span>
                                            <span v-else>Order By Implementation Unit</span></a>
                                    </li>
                                </ul>
                            </div>
                            <div class="card-body">
                                <div class="tab-content" id="custom-tabs-three-tabContent">
                                    <div class="tab-pane fade active show" id="custom-tabs-three-home" role="tabpanel"
                                        aria-labelledby="custom-tabs-three-home-tab">
                                        <div class="col-sm-12 text-center" data-wow-delay="0.1s">
                                            <a class="hitam">
                                                <button type="button" class="btn btn-success btn-sm text-white lebar2"
                                                    data-toggle="tooltip" data-placement="left" title="Unduh excel.."
                                                    @click="G_tableCSVTabel1('_Monitoring_Kegiatan_')">
                                                    <i class="fas fa-download"></i>
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Unduh Data .xlsx
                                                    </span>
                                                    <span v-else>
                                                        Download Data .xlsx
                                                    </span>
                                                </button>
                                            </a>
                                        </div>
                                        <div class="col-sm-12 text-center" data-wow-delay="0.1s">&nbsp;</div>
                                        <div class="col-sm-12" data-wow-delay="0.1s">
                                            <div class="table-responsive table-wrapper">
                                                <table class="table m-0" id="tabeldata1"
                                                    style="font-size: smaller !important;">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 50px;" rowspan="2">No</th>
                                                            <th style="width: 100px;" rowspan="2">CPMU/CPIU/PIU</th>
                                                            <th style="width: 100px;" rowspan="2">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Paket</span>
                                                                <span v-else>Package</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2" v-if="showColumnOuput">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Komponen</span>
                                                                <span v-else>Component</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2"
                                                                v-if="showColumnSubKomponen">
                                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Sub
                                                                    Komponen</span>
                                                                <span v-else>Sub Component</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2" v-if="showColumnOWP">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">OWP<br>(Rp.)</span>
                                                                <span v-else>OWP<br>(IDR)</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Nilai
                                                                    Kontrak<br>(Rp.)</span>
                                                                <span v-else>Contract value<br>(IDR)</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2"
                                                                v-if="showColumnPenyedia">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Penyedia</span>
                                                                <span v-else>Provider</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2" v-if="showColumnMulai">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Mulai</span>
                                                                <span v-else>Start</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2"
                                                                v-if="showColumnSelesai">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Selesai</span>
                                                                <span v-else>End</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2"
                                                                v-if="showColumnDurasi">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Durasi<br>(Bulan)</span>
                                                                <span v-else>Duration<br>(Month)</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2"
                                                                v-if="showColumnBerjalan">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Waktu<br>Durasi<br>Berjalan<br>(%)</span>
                                                                <span v-else>Running<br>Time<br>(%)</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2"
                                                                v-if="showColumnTersisa">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Waktu<br>Durasi<br>Tersisa<br>(%)</span>
                                                                <span v-else>Remaining<br>Duration<br>Time<br>(%)</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2"
                                                                v-if="showColumnKontrak">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Nomor
                                                                    Kontrak</span>
                                                                <span v-else>Contract Number</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2"
                                                                v-if="showColumnAdendum">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Adendum</span>
                                                                <span v-else>Addendum</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Target<br>Fisik
                                                                    (%)</span>
                                                                <span v-else>Physical<br>Target (%)</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Realisasi<br>Fisik
                                                                    (%)</span>
                                                                <span v-else>Physical<br>Realization (%)</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Deviasi<br>Fisik
                                                                    (%)</span>
                                                                <span v-else>Physical<br>Deviation (%)</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Realisasi<br>Keuangan<br>Kumulatif<br>(Rp.)</span>
                                                                <span v-else>Cumulative Financial Realization
                                                                    (IDR)</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Progres<br>Keuangan
                                                                    (%)</span>
                                                                <span v-else>Financial<br>Progress (%)</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Kategori<br>Pencairan<br>Anggaran</span>
                                                                <span v-else>Disbursement<br>Category<br>Status</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2"
                                                                v-if="showColumnKeterangan">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Keterangan</span>
                                                                <span v-else>Remark</span>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <template v-for="(datalist, urutlist) in datamaster2"
                                                        :key="urutlist">
                                                        <tbody>
                                                            <tr>
                                                                <td class="levelkomponen text-center">
                                                                    {{ urutlist + 1 }}
                                                                </td>
                                                                <td :colspan="colspan" class="levelkomponen">
                                                                    {{ datalist.jenis }}
                                                                </td>
                                                            </tr>
                                                            <template
                                                                v-for="(datalistdetail, urutlistdetail) in datalist.detail"
                                                                :key="urutlistdetail">
                                                                <tr>
                                                                    <td class="text-center" data-z="#,##0"
                                                                        :class="[datalistdetail.pv == 'FINISHED' ? 'text-white' : '', '']"
                                                                        :style="[datalistdetail.pv == 'FINISHED' ? 'background-color:' + datalistdetail.warna : '']">
                                                                        {{ urutlist + 1 }}.{{ urutlistdetail + 1 }}
                                                                    </td>
                                                                    <td :class="[datalistdetail.pv == 'FINISHED' ? 'text-white' : '', '']"
                                                                        :style="[datalistdetail.pv == 'FINISHED' ? 'background-color:' + datalistdetail.warna : '']">
                                                                        {{ datalistdetail.nama_satker }}
                                                                    </td>
                                                                    <td :style="[datalistdetail.pv == 'FINISHED' ? 'background-color:' + datalistdetail.warna : '']"
                                                                        :class="[datalistdetail.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                        <a href="javascript:void(0)"
                                                                            data-toggle="tooltip" data-placement="left"
                                                                            title="Lihat Data Progres.."
                                                                            @click="bukakurvas(datalistdetail.id, datalistdetail.MULAI, datalistdetail.SELESAI)">
                                                                            {{ datalistdetail.Nama_Kegiatan }}
                                                                        </a>
                                                                    </td :style="[datalistdetail.pv == 'FINISHED' ? 'background-color:' + datalistdetail.warna : '']"
                                                                        :class="[datalistdetail.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                    <td class="text-center" v-if="showColumnOuput"
                                                                        :style="[datalistdetail.pv == 'FINISHED' ? 'background-color:' + datalistdetail.warna : '']"
                                                                        :class="[datalistdetail.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                        {{ datalistdetail.Komponen }}
                                                                    </td>
                                                                    <td class="text-center" v-if="showColumnSubKomponen"
                                                                        :style="[datalistdetail.pv == 'FINISHED' ? 'background-color:' + datalistdetail.warna : '']"
                                                                        :class="[datalistdetail.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                        {{ datalistdetail.SubKomponen }}
                                                                    </td>
                                                                    <td class="text-right" v-if="showColumnOWP"
                                                                        :data-v="datalistdetail.OWP" data-z="#,##0.00"
                                                                        :style="[datalistdetail.pv == 'FINISHED' ? 'background-color:' + datalistdetail.warna : '']"
                                                                        :class="[datalistdetail.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                        {{ G_numFormat(datalistdetail.OWP) }}
                                                                    </td>
                                                                    <td class="text-right"
                                                                        :data-v="datalistdetail.NILAIKONTRAK"
                                                                        data-z="#,##0.00"
                                                                        :style="[datalistdetail.pv == 'FINISHED' ? 'background-color:' + datalistdetail.warna : '']"
                                                                        :class="[datalistdetail.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                        {{ G_numFormat(datalistdetail.NILAIKONTRAK) }}
                                                                    </td>
                                                                    <td class="text-justify" v-if="showColumnPenyedia"
                                                                        :style="[datalistdetail.pv == 'FINISHED' ? 'background-color:' + datalistdetail.warna : '']"
                                                                        :class="[datalistdetail.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                        {{ datalistdetail.KONTRAKTOR }}
                                                                    </td>
                                                                    <td class="text-center" v-if="showColumnMulai"
                                                                        :style="[datalistdetail.pv == 'FINISHED' ? 'background-color:' + datalistdetail.warna : '']"
                                                                        :class="[datalistdetail.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                        {{ G_formatDateNonWIB(datalistdetail.MULAI) }}
                                                                    </td>
                                                                    <td class="text-center" v-if="showColumnSelesai"
                                                                        :style="[datalistdetail.pv == 'FINISHED' ? 'background-color:' + datalistdetail.warna : '']"
                                                                        :class="[datalistdetail.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                        {{ G_formatDateNonWIB(datalistdetail.SELESAI) }}
                                                                    </td>
                                                                    <td class="text-center" v-if="showColumnDurasi"
                                                                        :data-v="datalistdetail.BULAN" data-z="#,##0"
                                                                        :style="[datalistdetail.pv == 'FINISHED' ? 'background-color:' + datalistdetail.warna : '']"
                                                                        :class="[datalistdetail.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                        {{ G_numKoma(datalistdetail.BULAN) }}
                                                                    </td>
                                                                    <td class="text-center" v-if="showColumnBerjalan"
                                                                        :data-v="datalistdetail.DURASI" data-z="#,##0"
                                                                        :style="[datalistdetail.pv == 'FINISHED' ? 'background-color:' + datalistdetail.warna : '']"
                                                                        :class="[datalistdetail.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                        {{ G_numKoma(datalistdetail.DURASI) }}
                                                                    </td>
                                                                    <td class="text-center" v-if="showColumnTersisa"
                                                                        :data-v="datalistdetail.DURASITERSISA"
                                                                        data-z="#,##0"
                                                                        :style="[datalistdetail.pv == 'FINISHED' ? 'background-color:' + datalistdetail.warna : '']"
                                                                        :class="[datalistdetail.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                        {{ G_numKoma(datalistdetail.DURASITERSISA) }}
                                                                    </td>
                                                                    <td class="text-justify" v-if="showColumnKontrak"
                                                                        :style="[datalistdetail.pv == 'FINISHED' ? 'background-color:' + datalistdetail.warna : '']"
                                                                        :class="[datalistdetail.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                        {{ datalistdetail.NOKONTRAK }}
                                                                    </td>
                                                                    <td class="text-center" v-if="showColumnAdendum"
                                                                        :style="[datalistdetail.pv == 'FINISHED' ? 'background-color:' + datalistdetail.warna : '']"
                                                                        :class="[datalistdetail.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                        {{ datalistdetail.ADENDUM }}
                                                                    </td>
                                                                    <td class="text-center"
                                                                        :data-v="datalistdetail.TARGET" data-z="#,##0"
                                                                        :style="[datalistdetail.pv == 'FINISHED' ? 'background-color:' + datalistdetail.warna : '']"
                                                                        :class="[datalistdetail.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                        {{ G_numKoma(datalistdetail.TARGET) }}
                                                                    </td>
                                                                    <td class="text-center"
                                                                        :data-v="datalistdetail.PROGRES" data-z="#,##0"
                                                                        :style="[datalistdetail.pv == 'FINISHED' ? 'background-color:' + datalistdetail.warna : '']"
                                                                        :class="[datalistdetail.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                        {{ G_numKoma(datalistdetail.PROGRES) }}
                                                                    </td>
                                                                    <td class="text-center"
                                                                        :data-v="datalistdetail.DEVIASI" data-z="#,##0"
                                                                        :style="[datalistdetail.pv == 'FINISHED' ? 'background-color:' + datalistdetail.warna : '']"
                                                                        :class="[datalistdetail.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                        {{ G_numKoma(datalistdetail.DEVIASI) }}
                                                                    </td>
                                                                    <td class="text-right"
                                                                        :data-v="datalistdetail.REALISASI_KUMULATIF"
                                                                        data-z="#,##0.00"
                                                                        :style="[datalistdetail.pv == 'FINISHED' ? 'background-color:' + datalistdetail.warna : '']"
                                                                        :class="[datalistdetail.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                        {{
                                                                            G_numFormat(datalistdetail.REALISASI_KUMULATIF)
                                                                        }}
                                                                    </td>
                                                                    <td class="text-center"
                                                                        :data-v="datalistdetail.PROGRESKEUANGAN"
                                                                        data-z="#,##0"
                                                                        :style="[datalistdetail.pv == 'FINISHED' ? 'background-color:' + datalistdetail.warna : '']"
                                                                        :class="[datalistdetail.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                        {{ G_numKoma(datalistdetail.PROGRESKEUANGAN) }}
                                                                    </td>
                                                                    <td class="text-center"
                                                                        :class="[datalistdetail.pv == 'FINISHED' ? 'text-white' : '', '']"
                                                                        :style="'background-color:' + datalistdetail.warna">
                                                                        {{ datalistdetail.pv }}
                                                                    </td>
                                                                    <td class="text-center" v-if="showColumnKeterangan"
                                                                        :style="[datalistdetail.pv == 'FINISHED' ? 'background-color:' + datalistdetail.warna : '']"
                                                                        :class="[datalistdetail.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                        {{ datalistdetail.KETERANGAN }}
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                        </tbody>
                                                    </template>
                                                    <tbody v-if="(datapesan == 'data kosong')">
                                                        <tr>
                                                            <td colspan="10">Data masih kosong</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade" id="custom-tabs-three-profile" role="tabpanel"
                                        aria-labelledby="custom-tabs-three-profile-tab">
                                        <div class="col-sm-12 text-center" data-wow-delay="0.1s">
                                            <a class="hitam">
                                                <button type="button" class="btn btn-success btn-sm text-white lebar2"
                                                    data-toggle="tooltip" data-placement="left" title="Unduh excel.."
                                                    @click="G_tableCSVTabel2('_Monitoring_Kegiatan_')">
                                                    <i class="fas fa-download"></i>
                                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">
                                                        Unduh Data .xlsx
                                                    </span>
                                                    <span v-else>
                                                        Download Data .xlsx
                                                    </span>
                                                </button>
                                            </a>
                                        </div>
                                        <div class="col-sm-12 text-center" data-wow-delay="0.1s">&nbsp;</div>
                                        <div class="col-sm-12" data-wow-delay="0.1s">
                                            <div class="table-responsive table-wrapper">
                                                <table class="table m-0" id="tabeldata1"
                                                    style="font-size: smaller !important;">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 50px;" rowspan="2">No</th>
                                                            <th style="width: 100px;" rowspan="2">CPMU/CPIU/PIU</th>
                                                            <th style="width: 100px;" rowspan="2">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Paket</span>
                                                                <span v-else>Package</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2" v-if="showColumnOuput">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Komponen</span>
                                                                <span v-else>Component</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2"
                                                                v-if="showColumnSubKomponen">
                                                                <span v-if="(bahasa === null) || (bahasa == 'ina')">Sub
                                                                    Komponen</span>
                                                                <span v-else>Sub Component</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2" v-if="showColumnOWP">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">OWP<br>(Rp.)</span>
                                                                <span v-else>OWP<br>(IDR)</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Nilai
                                                                    Kontrak<br>(Rp.)</span>
                                                                <span v-else>Contract value<br>(IDR)</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2"
                                                                v-if="showColumnPenyedia">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Penyedia</span>
                                                                <span v-else>Provider</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2" v-if="showColumnMulai">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Mulai</span>
                                                                <span v-else>Start</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2"
                                                                v-if="showColumnSelesai">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Selesai</span>
                                                                <span v-else>End</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2"
                                                                v-if="showColumnDurasi">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Durasi<br>(Bulan)</span>
                                                                <span v-else>Duration<br>(Month)</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2"
                                                                v-if="showColumnBerjalan">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Waktu<br>Durasi<br>Berjalan<br>(%)</span>
                                                                <span v-else>Running<br>Time<br>(%)</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2"
                                                                v-if="showColumnTersisa">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Waktu<br>Durasi<br>Tersisa<br>(%)</span>
                                                                <span v-else>Remaining<br>Duration<br>Time<br>(%)</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2"
                                                                v-if="showColumnKontrak">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Nomor
                                                                    Kontrak</span>
                                                                <span v-else>Contract Number</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2"
                                                                v-if="showColumnAdendum">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Adendum</span>
                                                                <span v-else>Addendum</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Target<br>Fisik
                                                                    (%)</span>
                                                                <span v-else>Physical<br>Target (%)</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Realisasi<br>Fisik
                                                                    (%)</span>
                                                                <span v-else>Physical<br>Realization (%)</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Deviasi<br>Fisik
                                                                    (%)</span>
                                                                <span v-else>Physical<br>Deviation (%)</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Realisasi<br>Keuangan<br>Kumulatif<br>(Rp.)</span>
                                                                <span v-else>Cumulative Financial Realization
                                                                    (IDR)</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Progres<br>Keuangan
                                                                    (%)</span>
                                                                <span v-else>Financial<br>Progress (%)</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Kategori<br>Pencairan<br>Anggaran</span>
                                                                <span v-else>Disbursement<br>Category<br>Status</span>
                                                            </th>
                                                            <th style="width: 50px;" rowspan="2"
                                                                v-if="showColumnKeterangan">
                                                                <span
                                                                    v-if="(bahasa === null) || (bahasa == 'ina')">Keterangan</span>
                                                                <span v-else>Remark</span>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <template v-for="(datalist, urutlist) in datamaster"
                                                        :key="urutlist">
                                                        <tbody>
                                                            <tr>
                                                                <td class="text-center" data-z="#,##0"
                                                                    :style="[datalist.pv == 'FINISHED' ? 'background-color:' + datalist.warna : '']"
                                                                    :class="[datalist.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                    {{ urutlist + 1 }}
                                                                </td>
                                                                <td :style="[datalist.pv == 'FINISHED' ? 'background-color:' + datalist.warna : '']"
                                                                    :class="[datalist.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                    {{ datalist.nama_satker }}
                                                                </td>
                                                                <td :style="[datalist.pv == 'FINISHED' ? 'background-color:' + datalist.warna : '']"
                                                                    :class="[datalist.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                    <a href="javascript:void(0)" data-placement="left"
                                                                        title="Lihat Data Progres.."
                                                                        @click="bukakurvas(datalist.id, datalist.MULAI, datalist.SELESAI)">
                                                                        {{ datalist.Nama_Kegiatan }}
                                                                    </a>
                                                                </td :style="[datalist.pv == 'FINISHED' ? 'background-color:' + datalist.warna : '']"
                                                                    :class="[datalist.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                <td class="text-center" v-if="showColumnOuput"
                                                                    :style="[datalist.pv == 'FINISHED' ? 'background-color:' + datalist.warna : '']"
                                                                    :class="[datalist.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                    {{ datalist.Komponen }}
                                                                </td>
                                                                <td class="text-center" v-if="showColumnSubKomponen"
                                                                    :style="[datalist.pv == 'FINISHED' ? 'background-color:' + datalist.warna : '']"
                                                                    :class="[datalist.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                    {{ datalist.SubKomponen }}
                                                                </td>
                                                                <td class="text-right" v-if="showColumnOWP"
                                                                    :data-v="datalist.OWP" data-z="#,##0.00"
                                                                    :style="[datalist.pv == 'FINISHED' ? 'background-color:' + datalist.warna : '']"
                                                                    :class="[datalist.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                    {{ G_numFormat(datalist.OWP) }}
                                                                </td>
                                                                <td class="text-right" :data-v="datalist.NILAIKONTRAK"
                                                                    data-z="#,##0.00"
                                                                    :style="[datalist.pv == 'FINISHED' ? 'background-color:' + datalist.warna : '']"
                                                                    :class="[datalist.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                    {{ G_numFormat(datalist.NILAIKONTRAK) }}
                                                                </td>
                                                                <td class="text-justify" v-if="showColumnPenyedia"
                                                                    :style="[datalist.pv == 'FINISHED' ? 'background-color:' + datalist.warna : '']"
                                                                    :class="[datalist.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                    {{ datalist.KONTRAKTOR }}
                                                                </td>
                                                                <td class="text-center" v-if="showColumnMulai"
                                                                    :style="[datalist.pv == 'FINISHED' ? 'background-color:' + datalist.warna : '']"
                                                                    :class="[datalist.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                    {{ G_formatDateNonWIB(datalist.MULAI) }}
                                                                </td>
                                                                <td class="text-center" v-if="showColumnSelesai"
                                                                    :style="[datalist.pv == 'FINISHED' ? 'background-color:' + datalist.warna : '']"
                                                                    :class="[datalist.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                    {{ G_formatDateNonWIB(datalist.SELESAI) }}
                                                                </td>
                                                                <td class="text-center" v-if="showColumnDurasi"
                                                                    :data-v="datalist.BULAN" data-z="#,##0"
                                                                    :style="[datalist.pv == 'FINISHED' ? 'background-color:' + datalist.warna : '']"
                                                                    :class="[datalist.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                    {{ G_numKoma(datalist.BULAN) }}
                                                                </td>
                                                                <td class="text-center" v-if="showColumnBerjalan"
                                                                    :data-v="datalist.DURASI" data-z="#,##0"
                                                                    :style="[datalist.pv == 'FINISHED' ? 'background-color:' + datalist.warna : '']"
                                                                    :class="[datalist.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                    {{ G_numKoma(datalist.DURASI) }}
                                                                </td>
                                                                <td class="text-center" v-if="showColumnTersisa"
                                                                    :data-v="datalist.DURASITERSISA" data-z="#,##0"
                                                                    :style="[datalist.pv == 'FINISHED' ? 'background-color:' + datalist.warna : '']"
                                                                    :class="[datalist.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                    {{ G_numKoma(datalist.DURASITERSISA) }}
                                                                </td>
                                                                <td class="text-justify" v-if="showColumnKontrak"
                                                                    :style="[datalist.pv == 'FINISHED' ? 'background-color:' + datalist.warna : '']"
                                                                    :class="[datalist.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                    {{ datalist.NOKONTRAK }}
                                                                </td>
                                                                <td class="text-center" v-if="showColumnAdendum"
                                                                    :style="[datalist.pv == 'FINISHED' ? 'background-color:' + datalist.warna : '']"
                                                                    :class="[datalist.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                    {{ datalist.ADENDUM }}
                                                                </td>
                                                                <td class="text-center" :data-v="datalist.TARGET"
                                                                    data-z="#,##0"
                                                                    :style="[datalist.pv == 'FINISHED' ? 'background-color:' + datalist.warna : '']"
                                                                    :class="[datalist.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                    {{ G_numKoma(datalist.TARGET) }}
                                                                </td>
                                                                <td class="text-center" :data-v="datalist.PROGRES"
                                                                    data-z="#,##0"
                                                                    :style="[datalist.pv == 'FINISHED' ? 'background-color:' + datalist.warna : '']"
                                                                    :class="[datalist.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                    {{ G_numKoma(datalist.PROGRES) }}
                                                                </td>
                                                                <td class="text-center" :data-v="datalist.DEVIASI"
                                                                    data-z="#,##0"
                                                                    :style="[datalist.pv == 'FINISHED' ? 'background-color:' + datalist.warna : '']"
                                                                    :class="[datalist.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                    {{ G_numKoma(datalist.DEVIASI) }}
                                                                </td>
                                                                <td class="text-right"
                                                                    :data-v="datalist.REALISASI_KUMULATIF"
                                                                    data-z="#,##0.00"
                                                                    :style="[datalist.pv == 'FINISHED' ? 'background-color:' + datalist.warna : '']"
                                                                    :class="[datalist.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                    {{ G_numFormat(datalist.REALISASI_KUMULATIF) }}
                                                                </td>
                                                                <td class="text-center"
                                                                    :data-v="datalist.PROGRESKEUANGAN" data-z="#,##0"
                                                                    :style="[datalist.pv == 'FINISHED' ? 'background-color:' + datalist.warna : '']"
                                                                    :class="[datalist.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                    {{ G_numKoma(datalist.PROGRESKEUANGAN) }}
                                                                </td>
                                                                <td class="text-center"
                                                                    :class="[datalist.pv == 'FINISHED' ? 'text-white' : '', '']"
                                                                    :style="'background-color:' + datalist.warna">
                                                                    {{ datalist.pv }}
                                                                </td>
                                                                <td class="text-center" v-if="showColumnKeterangan"
                                                                    :style="[datalist.pv == 'FINISHED' ? 'background-color:' + datalist.warna : '']"
                                                                    :class="[datalist.pv == 'FINISHED' ? 'text-white' : '', '']">
                                                                    {{ datalist.KETERANGAN }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                    <tbody v-if="(datapesan == 'data kosong')">
                                                        <tr>
                                                            <td colspan="5">Data masih kosong</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- /.card -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid blog py-2">&nbsp;</div>
    <!-- Contact End -->
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import xlsx from 'xlsx/dist/xlsx.full.min';
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    components: {
        Top, Footer, swal, DonutsChartMonitoringProyek: VueApexCharts
        , DonutsChartMonitoringWaktuProyek: VueApexCharts, DonutsChartMonitoringPVProyek: VueApexCharts
        , LineChartMonitoringProyek: VueApexCharts
    },
    data() {
        return {
            halamanloading: true,
            datapesan: '',
            datamaster: [],
            datamaster2: [],
            carikata: '',
            colspan: 9,
            datatahun: [],
            bahasa: localStorage.getItem("bahasasistem"),
            tanggalsinkron: new Date(),
            tanggaldatamonev: new Date(),
            showColumnStatusKegiatan: false,
            showColumnOuput: false,
            showColumnSubKomponen: false,
            showColumnPHOFHO: false,
            showColumnPenyedia: false,
            showColumnMulai: false,
            showColumnSelesai: false,
            showColumnDurasi: false,
            showColumnKontrak: false,
            showColumnAdendum: false,
            showColumnBerjalan: false,
            showColumnTersisa: false,
            showColumnOWP: false,
            showColumnTotalAWP: false,
            showColumnAWP: false,
            showColumnTotalDIPA: false,
            showColumnDIPA: false,
            showColumnCapaian: false,
            showColumnKeterangan: false,
            Nama_Kegiatan: '',
            Lokasi: '',
            KONTRAKTOR: '',
            NILAIKONTRAK: '',
            MULAI: '',
            SELESAI: '',
            ADENDUM: '',
            tanggal1: '',
            tanggal2: '',
            AWP: '',
            foto: '',
            foto_mingguke: '',
            kendala: '',
            tindaklanjut: '',
            datatahun: [],
            id_user: [],
            dataid_user: [],
            defaultSelectedid_user: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedid_user: '',
            lokasi: [],
            datalokasi: [],
            defaultSelectedlokasi: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedlokasi: '',
            jenispekerjaan: [],
            datajenispekerjaan: [],
            defaultSelectedjenispekerjaan: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedjenispekerjaan: '',
            seriesbar1: [],
            chartOptionsbar1: {
                title: {
                    text: 'Jumlah Total Kegiatan Dan Jenis Kegiatan',
                    align: 'center'
                },
                chart: {
                    type: 'bar',
                    height: 350,
                    toolbar: {
                        show: true
                    }
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            position: 'top', // top, center, bottom
                        },
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded'
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val;
                    },
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        colors: ["#304758"]
                    }
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: [],
                },
                yaxis: {
                    title: {
                        text: 'Jumlah Kegiatan'
                    }
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + " Kegiatan"
                        }
                    }
                }
            },
            dataresume: [],
            dataresumetotal: [],
            totalowp: 0,

            datamonitoring: [],
            seriesmonitoring: [],
            chartOptionsmonitoring: {
                chart: {
                    width: '100%',
                    height: 450,
                    type: 'line',
                    zoom: {
                        type: 'x',
                        enabled: true,
                        autoScaleYaxis: true
                    },
                    toolbar: {
                        autoSelected: 'zoom'
                    }
                },
                colors: ['#00CED1', '#FFD700', '#9370DB', '#4682B4', '#32CD32'],
                dataLabels: {
                    enabled: true,
                },
                stroke: {
                    curve: 'smooth'
                },
                title: {
                    text: 'Progres',
                    align: 'center'
                },
                grid: {
                    borderColor: '#e7e7e7',
                    row: {
                        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                        opacity: 0.5
                    },
                },
                markers: {
                    size: 1
                },
                xaxis: {
                    categories: [],
                    title: {
                        text: ''
                    }
                },
                yaxis: {
                    title: {
                        text: ''
                    },
                },
                legend: {
                    position: 'bottom',
                    floating: true,
                    offsetY: -10,
                    offsetX: -10,
                    show: true,
                }
            },

            tempjudul: [],
            temprencanafisik: [],
            temprencanakeu: [],
            temprealisasifisik: [],
            temprealisasikeu: [],
            tempdeviasifisik: [],
            tempdeviasikeu: [],
            awalminggu: 0,
            akhirminggu: 0,
            awalminggunya: 0,
            akhirminggunya: 0,
            idnya: '',
            mulainya: '',
            selesainya: '',
            kendalaarray: [],
            project_id: process.env.VUE_APP_PROJECT_ID,
        };
    },
    methods: {
        tutupmodalkurvas() {
            $('#costumModalkurva').modal('hide');
        },
        async eksportexcel() {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
                responseType: 'blob',
            });
            var random = Math.random();
            //alert(this.awalminggunya);
            //alert(this.akhirminggunya);
            const filename = 'Data.xlsx';
            await mainAPI5.get("parastapainnovationcetak-KurvaS?random=" + random + "&project_id=" + this.project_id + "&kode=" + this.idnya + "&awalminggu=" + this.awalminggunya + "&akhirminggu=" + this.akhirminggunya).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        async ambiltanggalterpilih(event) {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            //alert(event.target.value);
            await mainAPI5.get("parastapainnovationmonitoring-KurvaS?random=" + random + "&project_id=" + this.project_id + "&kode=" + this.idnya + "&awalminggu=" + this.awalminggu + "&akhirminggu=" + event.target.value).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);

                    if (this.datapesan == 'data diketemukan') {
                        this.seriesmonitoring = [];
                        this.chartOptionsmonitoring = {};
                        this.Nama_Kegiatan = Response.data.content.Nama_Kegiatan[0].Nama_Kegiatan;
                        this.Lokasi = Response.data.content.Nama_Kegiatan[0].Lokasi;
                        this.KONTRAKTOR = Response.data.content.Nama_Kegiatan[0].KONTRAKTOR;
                        this.NILAIKONTRAK = Response.data.content.Nama_Kegiatan[0].NILAIKONTRAK;
                        this.MULAI = Response.data.content.Nama_Kegiatan[0].MULAI;
                        this.SELESAI = Response.data.content.Nama_Kegiatan[0].SELESAI;
                        this.ADENDUM = Response.data.content.Nama_Kegiatan[0].ADENDUM;
                        this.tanggal1 = Response.data.content.Nama_Kegiatan[0].tanggal1;
                        this.tanggal2 = Response.data.content.Nama_Kegiatan[0].tanggal2;
                        this.AWP = Response.data.content.Nama_Kegiatan[0].AWP;
                        this.foto = Response.data.content.Nama_Kegiatan[0].foto;
                        this.foto_mingguke = Response.data.content.Nama_Kegiatan[0].foto_mingguke;
                        this.kendalaarray = Response.data.content.Kendala;
                        this.kendala = atob(Response.data.content.Nama_Kegiatan[0].kendala);
                        this.tindaklanjut = atob(Response.data.content.Nama_Kegiatan[0].tindaklanjut);
                        this.tempjudul = [];
                        this.temprencanafisik = [];
                        this.temprencanakeu = [];
                        this.temprealisasifisik = [];
                        this.temprealisasikeu = [];
                        this.tempdeviasifisik = [];
                        this.tempdeviasikeu = [];
                        this.awalminggu = 0;
                        this.akhirminggu = 0;
                        //this.awalminggunya = 0;
                        //this.akhirminggunya = 0;

                        for (let i = 0; i < Response.data.content.data.length; i++) {
                            this.tempjudul.push(Response.data.content.data[i].minggu_ke);
                            this.temprencanafisik.push(Response.data.content.data[i].rencana_fisik);
                            this.temprencanakeu.push(Response.data.content.data[i].rencana_keuangan);
                            this.temprealisasifisik.push(Response.data.content.data[i].real_fisik);
                            this.temprealisasikeu.push(Response.data.content.data[i].real_keuangan);
                            this.tempdeviasifisik.push(Response.data.content.data[i].deviasi_fisik);
                            this.tempdeviasikeu.push(Response.data.content.data[i].deviasi_keuangan);
                        }
                        this.awalminggu = Response.data.content.awalminggu;
                        this.akhirminggu = Response.data.content.jumlahminggu;
                        //this.awalminggunya = Response.data.content.awalminggu;
                        //this.akhirminggunya = Response.data.content.jumlahminggu;
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            var textjudul = 'Progres Realisasi Fisik Dan Keuangan';
                            var textrencanafisik = 'Rencana Fisik';
                            var textrencanakeuangan = 'Rencana Keuangan';
                            var textrealisasifisik = 'Realisasi Fisik';
                            var textrealisasikeuangan = 'Realisasi Keuangan';
                            var textaxis = 'Capaian';
                        }
                        else {
                            var textjudul = 'Physical and Financial Realization Progress';
                            var textrencanafisik = 'Physical Plan';
                            var textrencanakeuangan = 'Financial Plan';
                            var textrealisasifisik = 'Physical Realization';
                            var textrealisasikeuangan = 'Financial Realization';
                            var textaxis = 'Achievements';
                        }

                        this.seriesmonitoring.push(
                            {
                                name: textrencanafisik,
                                data: this.temprencanafisik
                            },
                            {
                                name: textrencanakeuangan,
                                data: this.temprencanakeu
                            },
                            {
                                name: textrealisasifisik,
                                data: this.temprealisasifisik
                            },
                            {
                                name: textrealisasikeuangan,
                                data: this.temprealisasikeu
                            }
                        )
                        //alert(temptahun);
                        this.chartOptionsmonitoring = {
                            title: {
                                text: textjudul,
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'PragmaticaBook, Arial',
                                    color: '#263238'
                                },
                            },
                            xaxis: {
                                categories: this.tempjudul,
                            },
                            yaxis: {
                                title: {
                                    text: textaxis
                                },
                                value: {

                                },
                            },
                            legend: {
                                position: 'bottom',
                                floating: true,
                                offsetY: 10,
                                offsetX: -10,
                                show: true,
                            }
                        };
                        this.halamanloading = false;
                        $('#costumModalkurva').modal('show');
                    }
                    else {
                        this.seriesmonitoring = [];
                        this.chartOptionsmonitoring = {};
                        this.Nama_Kegiatan = '';
                        this.Lokasi = '';
                        this.KONTRAKTOR = '';
                        this.NILAIKONTRAK = '';
                        this.MULAI = '';
                        this.SELESAI = '';
                        this.ADENDUM = '';
                        this.tanggal1 = '';
                        this.tanggal2 = '';
                        this.AWP = '';
                        this.foto = '';
                        this.foto_mingguke = '';
                        this.kendala = '';
                        this.kendalaarray = [];
                        this.tindaklanjut = '';
                        this.akhirminggu = 0;
                        this.awalminggu = 0;
                        //this.awalminggunya = 0;
                        //this.akhirminggunya = 0;
                        this.halamanloading = false;
                    }

                }
            ).catch(error => {
                console.log(error);
                this.seriesmonitoring = [];
                this.chartOptionsmonitoring = {};
                this.Nama_Kegiatan = '';
                this.Lokasi = '';
                this.KONTRAKTOR = '';
                this.NILAIKONTRAK = '';
                this.MULAI = '';
                this.SELESAI = '';
                this.ADENDUM = '';
                this.tanggal1 = '';
                this.tanggal2 = '';
                this.AWP = '';
                this.foto = '';
                this.foto_mingguke = '';
                this.kendala = '';
                this.kendalaarray = [];
                this.tindaklanjut = '';
                this.akhirminggu = 0;
                this.awalminggu = 0;
                //this.awalminggunya = 0;
                //this.akhirminggunya = 0;
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
        async bukakurvas(id, mulai, selesai) {
            //alert(id);
            this.idnya = id;
            this.mulainya = mulai;
            this.selesainya = selesai;
            this.Nama_Kegiatan = '';
            this.Lokasi = '';
            this.KONTRAKTOR = '';
            this.NILAIKONTRAK = '';
            this.MULAI = '';
            this.SELESAI = '';
            this.ADENDUM = '';
            this.tanggal1 = '';
            this.tanggal2 = '';
            this.AWP = '';
            this.foto = '';
            this.foto_mingguke = '';
            this.kendala = '';
            this.kendalaarray = [];
            this.tindaklanjut = '';
            if (mulai == '0000-00-00' || selesai == '0000-00-00' || mulai == '' || selesai == '' || mulai == null || selesai == null) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Tanggal kontrak belum diisi..',
                });
                return false;
            }
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            //alert(this.akhirminggu);
            await mainAPI5.get("parastapainnovationmonitoring-KurvaS?random=" + random + "&project_id=" + this.project_id + "&kode=" + id + "&awalminggu=" + this.awalminggu + "&akhirminggu=" + this.akhirminggu).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.Nama_Kegiatan = Response.data.content.Nama_Kegiatan[0].Nama_Kegiatan;
                        this.Lokasi = Response.data.content.Nama_Kegiatan[0].Lokasi;
                        this.KONTRAKTOR = Response.data.content.Nama_Kegiatan[0].KONTRAKTOR;
                        this.NILAIKONTRAK = Response.data.content.Nama_Kegiatan[0].NILAIKONTRAK;
                        this.MULAI = Response.data.content.Nama_Kegiatan[0].MULAI;
                        this.SELESAI = Response.data.content.Nama_Kegiatan[0].SELESAI;
                        this.ADENDUM = Response.data.content.Nama_Kegiatan[0].ADENDUM;
                        this.tanggal1 = Response.data.content.Nama_Kegiatan[0].tanggal1;
                        this.tanggal2 = Response.data.content.Nama_Kegiatan[0].tanggal2;
                        this.AWP = Response.data.content.Nama_Kegiatan[0].AWP;
                        this.foto = Response.data.content.Nama_Kegiatan[0].foto;
                        this.foto_mingguke = Response.data.content.Nama_Kegiatan[0].foto_mingguke;
                        this.kendalaarray = Response.data.content.Kendala;
                        this.kendala = atob(Response.data.content.Nama_Kegiatan[0].kendala);
                        this.tindaklanjut = atob(Response.data.content.Nama_Kegiatan[0].tindaklanjut);
                        this.tempjudul = [];
                        this.temprencanafisik = [];
                        this.temprencanakeu = [];
                        this.temprealisasifisik = [];
                        this.temprealisasikeu = [];
                        this.tempdeviasifisik = [];
                        this.tempdeviasikeu = [];
                        this.awalminggu = 0;
                        this.akhirminggu = 0;
                        this.awalminggunya = 0;
                        this.akhirminggunya = 0;
                        this.seriesmonitoring = [];
                        this.chartOptionsmonitoring = {};

                        for (let i = 0; i < Response.data.content.data.length; i++) {
                            this.tempjudul.push(Response.data.content.data[i].minggu_ke);
                            this.temprencanafisik.push(Response.data.content.data[i].rencana_fisik);
                            this.temprencanakeu.push(Response.data.content.data[i].rencana_keuangan);
                            this.temprealisasifisik.push(Response.data.content.data[i].real_fisik);
                            this.temprealisasikeu.push(Response.data.content.data[i].real_keuangan);
                            this.tempdeviasifisik.push(Response.data.content.data[i].deviasi_fisik);
                            this.tempdeviasikeu.push(Response.data.content.data[i].deviasi_keuangan);
                        }
                        this.awalminggu = Response.data.content.awalminggu;
                        this.akhirminggu = Response.data.content.jumlahminggu;
                        this.awalminggunya = Response.data.content.awalminggu;
                        this.akhirminggunya = Response.data.content.jumlahminggu;
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            var textjudul = 'Progres Realisasi Fisik Dan Keuangan';
                            var textrencanafisik = 'Rencana Fisik';
                            var textrencanakeuangan = 'Rencana Keuangan';
                            var textrealisasifisik = 'Realisasi Fisik';
                            var textrealisasikeuangan = 'Realisasi Keuangan';
                            var textaxis = 'Capaian';
                        }
                        else {
                            var textjudul = 'Physical and Financial Realization Progress';
                            var textrencanafisik = 'Physical Plan';
                            var textrencanakeuangan = 'Financial Plan';
                            var textrealisasifisik = 'Physical Realization';
                            var textrealisasikeuangan = 'Financial Realization';
                            var textaxis = 'Achievements';
                        }

                        this.seriesmonitoring.push(
                            {
                                name: textrencanafisik,
                                data: this.temprencanafisik
                            },
                            {
                                name: textrencanakeuangan,
                                data: this.temprencanakeu
                            },
                            {
                                name: textrealisasifisik,
                                data: this.temprealisasifisik
                            },
                            {
                                name: textrealisasikeuangan,
                                data: this.temprealisasikeu
                            }
                        )
                        //alert(temptahun);
                        this.chartOptionsmonitoring = {
                            title: {
                                text: textjudul,
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'PragmaticaBook, Arial',
                                    color: '#263238'
                                },
                            },
                            xaxis: {
                                categories: this.tempjudul,
                            },
                            yaxis: {
                                title: {
                                    text: textaxis
                                },
                            },
                            legend: {
                                position: 'bottom',
                                floating: true,
                                offsetY: 10,
                                offsetX: -5,
                                show: true,
                            }
                        };
                        this.halamanloading = false;
                    }
                    else {
                        this.seriesmonitoring = [];
                        this.chartOptionsmonitoring = {};
                        this.Nama_Kegiatan = '';
                        this.Lokasi = '';
                        this.KONTRAKTOR = '';
                        this.NILAIKONTRAK = '';
                        this.MULAI = '';
                        this.SELESAI = '';
                        this.ADENDUM = '';
                        this.tanggal1 = '';
                        this.tanggal2 = '';
                        this.AWP = '';
                        this.foto = '';
                        this.foto_mingguke = '';
                        this.kendala = '';
                        this.kendalaarray = [];
                        this.tindaklanjut = '';
                        this.akhirminggu = 0;
                        this.awalminggu = 0;
                        this.awalminggunya = 0;
                        this.akhirminggunya = 0;
                        this.halamanloading = false;
                    }

                }
            ).catch(error => {
                console.log(error);
                this.seriesmonitoring = [];
                this.chartOptionsmonitoring = {};
                this.Nama_Kegiatan = '';
                this.Lokasi = '';
                this.KONTRAKTOR = '';
                this.NILAIKONTRAK = '';
                this.MULAI = '';
                this.SELESAI = '';
                this.ADENDUM = '';
                this.tanggal1 = '';
                this.tanggal2 = '';
                this.AWP = '';
                this.foto = '';
                this.foto_mingguke = '';
                this.kendala = '';
                this.kendalaarray = [];
                this.tindaklanjut = '';
                this.akhirminggu = 0;
                this.awalminggu = 0;
                this.awalminggunya = 0;
                this.akhirminggunya = 0;
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            await mainAPI5.get("parastapainnovationmonitoring-KurvaS?random=" + random + "&project_id=" + this.project_id + "&kode=" + id + "&awalminggu=" + this.awalminggu + "&akhirminggu=" + this.akhirminggu).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.Nama_Kegiatan = Response.data.content.Nama_Kegiatan[0].Nama_Kegiatan;
                        this.Lokasi = Response.data.content.Nama_Kegiatan[0].Lokasi;
                        this.KONTRAKTOR = Response.data.content.Nama_Kegiatan[0].KONTRAKTOR;
                        this.NILAIKONTRAK = Response.data.content.Nama_Kegiatan[0].NILAIKONTRAK;
                        this.MULAI = Response.data.content.Nama_Kegiatan[0].MULAI;
                        this.SELESAI = Response.data.content.Nama_Kegiatan[0].SELESAI;
                        this.ADENDUM = Response.data.content.Nama_Kegiatan[0].ADENDUM;
                        this.tanggal1 = Response.data.content.Nama_Kegiatan[0].tanggal1;
                        this.tanggal2 = Response.data.content.Nama_Kegiatan[0].tanggal2;
                        this.AWP = Response.data.content.Nama_Kegiatan[0].AWP;
                        this.foto = Response.data.content.Nama_Kegiatan[0].foto;
                        this.foto_mingguke = Response.data.content.Nama_Kegiatan[0].foto_mingguke;
                        this.kendalaarray = Response.data.content.Kendala;
                        this.kendala = atob(Response.data.content.Nama_Kegiatan[0].kendala);
                        this.tindaklanjut = atob(Response.data.content.Nama_Kegiatan[0].tindaklanjut);
                        this.tempjudul = [];
                        this.temprencanafisik = [];
                        this.temprencanakeu = [];
                        this.temprealisasifisik = [];
                        this.temprealisasikeu = [];
                        this.tempdeviasifisik = [];
                        this.tempdeviasikeu = [];
                        this.awalminggu = 0;
                        this.akhirminggu = 0;
                        this.awalminggunya = 0;
                        this.akhirminggunya = 0;
                        this.seriesmonitoring = [];
                        this.chartOptionsmonitoring = {};

                        for (let i = 0; i < Response.data.content.data.length; i++) {
                            this.tempjudul.push(Response.data.content.data[i].minggu_ke);
                            this.temprencanafisik.push(Response.data.content.data[i].rencana_fisik);
                            this.temprencanakeu.push(Response.data.content.data[i].rencana_keuangan);
                            this.temprealisasifisik.push(Response.data.content.data[i].real_fisik);
                            this.temprealisasikeu.push(Response.data.content.data[i].real_keuangan);
                            this.tempdeviasifisik.push(Response.data.content.data[i].deviasi_fisik);
                            this.tempdeviasikeu.push(Response.data.content.data[i].deviasi_keuangan);
                        }
                        this.awalminggu = Response.data.content.awalminggu;
                        this.akhirminggu = Response.data.content.jumlahminggu;
                        this.awalminggunya = Response.data.content.awalminggu;
                        this.akhirminggunya = Response.data.content.jumlahminggu;
                        if ((this.bahasa === null) || (this.bahasa == 'ina')) {
                            var textjudul = 'Progres Realisasi Fisik Dan Keuangan';
                            var textrencanafisik = 'Rencana Fisik';
                            var textrencanakeuangan = 'Rencana Keuangan';
                            var textrealisasifisik = 'Realisasi Fisik';
                            var textrealisasikeuangan = 'Realisasi Keuangan';
                            var textaxis = 'Capaian';
                        }
                        else {
                            var textjudul = 'Physical and Financial Realization Progress';
                            var textrencanafisik = 'Physical Plan';
                            var textrencanakeuangan = 'Financial Plan';
                            var textrealisasifisik = 'Physical Realization';
                            var textrealisasikeuangan = 'Financial Realization';
                            var textaxis = 'Achievements';
                        }

                        this.seriesmonitoring.push(
                            {
                                name: textrencanafisik,
                                data: this.temprencanafisik
                            },
                            {
                                name: textrencanakeuangan,
                                data: this.temprencanakeu
                            },
                            {
                                name: textrealisasifisik,
                                data: this.temprealisasifisik
                            },
                            {
                                name: textrealisasikeuangan,
                                data: this.temprealisasikeu
                            }
                        )
                        //alert(temptahun);
                        this.chartOptionsmonitoring = {
                            title: {
                                text: textjudul,
                                align: 'center',
                                margin: 10,
                                offsetX: 0,
                                offsetY: 0,
                                floating: false,
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    fontFamily: 'PragmaticaBook, Arial',
                                    color: '#263238'
                                },
                            },
                            xaxis: {
                                categories: this.tempjudul,
                            },
                            yaxis: {
                                title: {
                                    text: textaxis
                                },
                            },
                            legend: {
                                position: 'bottom',
                                floating: true,
                                offsetY: 10,
                                offsetX: -5,
                                show: true,
                            }
                        };
                        this.halamanloading = false;
                        $('#costumModalkurva').modal('show');
                    }
                    else {
                        this.seriesmonitoring = [];
                        this.chartOptionsmonitoring = {};
                        this.Nama_Kegiatan = '';
                        this.Lokasi = '';
                        this.KONTRAKTOR = '';
                        this.NILAIKONTRAK = '';
                        this.MULAI = '';
                        this.SELESAI = '';
                        this.ADENDUM = '';
                        this.tanggal1 = '';
                        this.tanggal2 = '';
                        this.AWP = '';
                        this.foto = '';
                        this.foto_mingguke = '';
                        this.kendala = '';
                        this.kendalaarray = [];
                        this.tindaklanjut = '';
                        this.akhirminggu = 0;
                        this.awalminggu = 0;
                        this.awalminggunya = 0;
                        this.akhirminggunya = 0;
                        this.halamanloading = false;
                    }

                }
            ).catch(error => {
                console.log(error);
                this.seriesmonitoring = [];
                this.chartOptionsmonitoring = {};
                this.Nama_Kegiatan = '';
                this.Lokasi = '';
                this.KONTRAKTOR = '';
                this.NILAIKONTRAK = '';
                this.MULAI = '';
                this.SELESAI = '';
                this.ADENDUM = '';
                this.tanggal1 = '';
                this.tanggal2 = '';
                this.AWP = '';
                this.foto = '';
                this.foto_mingguke = '';
                this.kendala = '';
                this.kendalaarray = [];
                this.tindaklanjut = '';
                this.akhirminggu = 0;
                this.awalminggu = 0;
                this.awalminggunya = 0;
                this.akhirminggunya = 0;
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

        },
        ubahnya(shownya, idnya) {
            if (shownya == 'showColumnOuput') {
                this.showColumnOuput = !this.showColumnOuput;
            }
            if (shownya == 'showColumnSubKomponen') {
                this.showColumnSubKomponen = !this.showColumnSubKomponen;
            }
            if (shownya == 'showColumnStatusKegiatan') {
                this.showColumnStatusKegiatan = !this.showColumnStatusKegiatan;
            }
            if (shownya == 'showColumnPHOFHO') {
                this.showColumnPHOFHO = !this.showColumnPHOFHO;
            }
            if (shownya == 'showColumnPenyedia') {
                this.showColumnPenyedia = !this.showColumnPenyedia;
            }
            if (shownya == 'showColumnMulai') {
                this.showColumnMulai = !this.showColumnMulai;
            }
            if (shownya == 'showColumnSelesai') {
                this.showColumnSelesai = !this.showColumnSelesai;
            }
            if (shownya == 'showColumnDurasi') {
                this.showColumnDurasi = !this.showColumnDurasi;
            }
            if (shownya == 'showColumnKontrak') {
                this.showColumnKontrak = !this.showColumnKontrak;
            }
            if (shownya == 'showColumnAdendum') {
                this.showColumnAdendum = !this.showColumnAdendum;
            }
            if (shownya == 'showColumnBerjalan') {
                this.showColumnBerjalan = !this.showColumnBerjalan;
            }
            if (shownya == 'showColumnTersisa') {
                this.showColumnTersisa = !this.showColumnTersisa;
            }
            if (shownya == 'showColumnOWP') {
                this.showColumnOWP = !this.showColumnOWP;
            }
            if (shownya == 'showColumnTotalAWP') {
                this.showColumnTotalAWP = !this.showColumnTotalAWP;
            }
            if (shownya == 'showColumnAWP') {
                this.showColumnAWP = !this.showColumnAWP;
            }
            if (shownya == 'showColumnTotalDIPA') {
                this.showColumnTotalDIPA = !this.showColumnTotalDIPA;
            }
            if (shownya == 'showColumnDIPA') {
                this.showColumnDIPA = !this.showColumnDIPA;
            }
            if (shownya == 'showColumnCapaian') {
                this.showColumnCapaian = !this.showColumnCapaian;
            }
            if (shownya == 'showColumnKeterangan') {
                this.showColumnKeterangan = !this.showColumnKeterangan;
            }

            if (document.getElementById(idnya).checked == true) {
                this.colspan = this.colspan + 1;
            }
            else {
                this.colspan = this.colspan - 1;
            }
        },
        async G_tableCSVTabel1(namefile) {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
                responseType: 'blob',
            });
            var random = Math.random();
            //alert(this.awalminggunya);
            //alert(this.akhirminggunya);
            const filename = this.G_formatDate(Date(), 'd-M-Y') + '_' + namefile + '.xlsx';
            await mainAPI5.get("parastapainnovationcetakkegiatan-Kegiatan?random=" + random + "&project_id=" + this.project_id + "&showColumnOuput=" + this.showColumnOuput
                + "&showColumnSubKomponen=" + this.showColumnSubKomponen + "&showColumnOWP=" + this.showColumnOWP + "&showColumnPenyedia=" + this.showColumnPenyedia
                + "&showColumnKontrak=" + this.showColumnKontrak + "&showColumnAdendum=" + this.showColumnAdendum + "&showColumnMulai=" + this.showColumnMulai
                + "&showColumnSelesai=" + this.showColumnSelesai + "&showColumnDurasi=" + this.showColumnDurasi + "&showColumnBerjalan=" + this.showColumnBerjalan
                + "&showColumnTersisa=" + this.showColumnTersisa + "&showColumnKeterangan=" + this.showColumnKeterangan
            ).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        async G_tableCSVTabel2(namefile) {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
                responseType: 'blob',
            });
            var random = Math.random();
            //alert(this.awalminggunya);
            //alert(this.akhirminggunya);
            const filename = this.G_formatDate(Date(), 'd-M-Y') + '_' + namefile + '.xlsx';
            await mainAPI5.get("parastapainnovationcetakkegiatan-Monev?random=" + random + "&project_id=" + this.project_id + "&showColumnOuput=" + this.showColumnOuput
                + "&showColumnSubKomponen=" + this.showColumnSubKomponen + "&showColumnOWP=" + this.showColumnOWP + "&showColumnPenyedia=" + this.showColumnPenyedia
                + "&showColumnKontrak=" + this.showColumnKontrak + "&showColumnAdendum=" + this.showColumnAdendum + "&showColumnMulai=" + this.showColumnMulai
                + "&showColumnSelesai=" + this.showColumnSelesai + "&showColumnDurasi=" + this.showColumnDurasi + "&showColumnBerjalan=" + this.showColumnBerjalan
                + "&showColumnTersisa=" + this.showColumnTersisa + "&showColumnKeterangan=" + this.showColumnKeterangan
            ).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationmonitoring-FilterMonev?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    this.datamaster = [];
                    this.datamaster2 = [];
                    this.datakonten = [];
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datapesan = Response.data.message;
                        this.colspan = 9;
                        this.datatahun = [];
                        //this.colspan = Response.data.content.jumlahtahun;
                        //alert(Response.data.content.jumlahtahun);
                        this.datatahun = Response.data.content.data[0].Tahun;
                        this.tanggalsinkron = Response.data.content.data[0].TanggalSinkronisasi;
                        this.tanggaldatamonev = Response.data.content.data[0].TanggalDataMonev;
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data[0].Content;
                        this.datamaster2 = Response.data.content.data2;
                        this.halamanloading = false;
                    }
                    else {
                        this.datapesan = '';
                        this.tanggalsinkron = new Date();
                        this.tanggaldatamonev = new Date();
                        this.colspan = 9;
                        this.datatahun = [];
                        //alert(this.datapesan);
                        this.halamanloading = false;

                    }
                }
            ).catch(error => {
                this.datapesan = '';
                this.tanggalsinkron = new Date();
                this.tanggaldatamonev = new Date();
                this.colspan = 9;
                this.datatahun = [];
                this.halamanloading = false;
            });
        },
    },
    mounted() {
        this.ambildata();
    },
}
</script>

<style></style>